// import React, { PropsWithChildren, useReducer } from 'react'
import mapbox from '../../helpers/mapbox'
import { Settings } from '../../settings-types'
import { SiteInfo } from 'shared'

export type QueryState = {
  lat?: number
  lng?: number
  q?: string
  radius?: string
  sort?: string
  type?: string
  mapboxPlainText?: string[]
}

type MapboxContextItem = {
  text: string
}

export const queryContextReducer = async (
  settings: Settings,
  siteInfo: SiteInfo | null,
  payload: QueryState
) => {
  const mapboxInstance = mapbox(settings, siteInfo)

  if (payload.q) {
    try {
      const res = await mapboxInstance.forwardGeocode(payload.q, {
        autocomplete: false,
      })
      const [lng, lat] = res.features[0].center
      const featureWithContext = res.features.find(
        (feature: { context?: Array<MapboxContextItem> }) =>
          feature.context && feature.context.length > 0
      )
      const mapboxPlainText: string[] = featureWithContext?.context
        ? featureWithContext.context.map((item: MapboxContextItem) => item.text)
        : []

      mapboxPlainText.push(res.features[0].text as string)
      payload = {
        ...payload,
        lat,
        lng,
        mapboxPlainText,
      }
    } catch (error) {
      payload = { ...payload, lat: 0, lng: 0 }
      console.error(error)
    }

    return payload
  }

  return {}
}
